import { useEffect, useState } from "react";
import Login from "./Login";
import Dash from "../dash/page";
import { getMe } from "../helper/sso";
import { Callout, Spinner } from "@radix-ui/themes";
import TosModal from "../components/TosModal";

type State =
  | { status: "loading" }
  | { status: "authenticated"; user: any }
  | { status: "unauthenticated" };

export default function AuthGate() {
  const [state, setState] = useState<State>({ status: "loading" });
  const [tosAccepted, setTosAccepted] = useState(false);

  useEffect(() => {
    const run = async () => {
      const me = await getMe();

      if (me && me.authenticated) {
        setState({ status: "authenticated", user: me.user });
      } else {
        setState({ status: "unauthenticated" });
      }
    };

    run();
  }, []);

  if (state.status === "loading") {
    return (
      <Callout.Root m="6" variant="surface">
        <Callout.Icon>
          <Spinner size="3" />
        </Callout.Icon>
        <Callout.Text weight="bold" size="3">
          Checking authentication...
        </Callout.Text>
      </Callout.Root>
    );
  }

  if (state.status === "unauthenticated") {
    return (
      <>
        <TosModal open={!tosAccepted} onAccept={() => setTosAccepted(true)} />
        <Login />
      </>
    );
  }

  return <Dash />;
}
